import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { formatURL } from '../../../utils';

import { cleanErrors, editPurchase, cleanStatesPurchaseMobile, clearCoupon } from '../../../actions/purchaseActions';
import BoxValues from './BoxValues';
import BoxCoupon from './BoxCoupon';
import BoxPlan from './BoxPlan';
import ConfirmPurchase from './ConfirmPurchase';
import BoxInsureds from './BoxInsureds';
import BoxPaymentMethod from './BoxPaymentMethod';
import BoxContact from './BoxContact';
import BoxCreditCoupon from './box_credit_coupon/index';

class PurchaseDescriptionMobile extends Component {
  constructor(props) {
    super(props);

    const begin_date = this.props.match.params.begin_date.split('-'),
      end_date = this.props.match.params.end_date.split('-');

    // TODO: use --> this.props.destinations.filter(destination => destination.slug === this.props.match.params.destination)[0].name;
    this.destination = 'teste';
    this.begin_date = `${begin_date[2]}/${begin_date[1]}/${begin_date[0]}`;
    this.end_date = `${end_date[2]}/${end_date[1]}/${end_date[0]}`;
    this.card_descricao = React.createRef();
    this.editCupom = this.editCupom.bind(this);
    this.scrollToRef = this.scrollToRef.bind(this);
  }

  selectedPaymentMethod(paymentMethods) {
    for (var pm in paymentMethods) {
      if (paymentMethods[pm].selected) {
        return paymentMethods[pm].id;
      }
    }
  }

  backSearch = (e) => {
    const location = {
      pathname: formatURL(
        this.props.match,
        `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
        null
      ),
    };
    this.props.cleanStatesPurchaseMobile();
    this.props.cleanErrors();
    this.props.history.push(location);
  };

  scrollToRef() {
    this.card_descricao.current.scroll(0, 250);
  }

  editCupom() {
    this.card_descricao.current.scroll(0, 250);
    this.props.clearCoupon();
  }

  render() {
    const couponErrorPaymentMethod =
      this.props.couponInfo.payment_method !== undefined &&
      this.props.couponInfo.payment_method !== null &&
      this.selectedPaymentMethod(this.props.payment_methods) !== this.props.couponInfo.payment_method;

    return (
      <div
        className="card-descricao mobile"
        ref={this.card_descricao}
        key={2}
        style={{ display: this.props.stagePurchase !== 4 && this.props.mobile ? 'none' : 'block' }}
      >
        <div className="title-descricao">
          <h4 className="title-descricao__title">Revise seu pedido</h4>
          <p>Verifique todos os dados dos segurados e da compra antes de finalizar a compra.</p>
        </div>

        <BoxCoupon scrollToRef={() => this.scrollToRef()} />
        <BoxCreditCoupon />
        <BoxValues />

        <div className="title-box">
          <span>Destino e cobertura</span>
          <span onClick={this.backSearch} data-cy="edit-destination" className="edit-btn">
            Editar
          </span>
        </div>
        <BoxPlan />

        <div className="title-box">
          <span>Segurados</span>
          <span onClick={(_) => this.props.editPurchase(1)} data-cy="edit-insureds" className="edit-btn">
            Editar
          </span>
        </div>
        <BoxInsureds />

        <div className="title-box">
          <span>Forma de pagamento</span>
          <span onClick={(_) => this.props.editPurchase(2)} data-cy="edit-payment-method" className="edit-btn">
            Editar
          </span>
        </div>
        <BoxPaymentMethod />

        <div className="title-box">
          <span>Contato da compra</span>
          <span onClick={(_) => this.props.editPurchase(3)} data-cy="edit-contact-data" className="edit-btn">
            Editar
          </span>
        </div>
        <BoxContact />
        <ConfirmPurchase />
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      stagePurchase: state.purchase.stagePurchase,
      mobile: state.mobile.mobileActive,
      couponInfo: state.purchase.coupon,
      payment_methods: state.purchase.paymentMethods,
    }),
    {
      cleanErrors,
      editPurchase,
      cleanStatesPurchaseMobile,
      clearCoupon,
    }
  )(PurchaseDescriptionMobile)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/PurchaseDescriptionMobile.jsx